import { useState, useCallback } from 'react';
import { useToggleWithAnimation } from '@edreamsodigeo/prisma-design-system';

export const useSimpleModal = (open = false) => {
  const [isOpen, setOpen] = useState(open);
  const modalProps = useToggleWithAnimation({ isOpen });
  const closeModal = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const openModal = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  return { modalProps, openModal, closeModal, isOpen };
};
